<script>
// Renders plain (optionally multi-line) text as the site's staggered title reveal:
// each line becomes a .title-anim-wrapper > .title-anim.td-{i} segment.
// Keeps wordings as plain text while preserving the animation.
export default {
  name: 'AnimText',
  functional: true,
  render(h, { props }) {
    const text = props.text != null ? String(props.text) : ''
    return text.split('\n').map((line, i) =>
      h('span', { class: 'title-anim-wrapper' }, [
        h('span', { class: ['title-anim', 'td-' + i], domProps: { innerHTML: line } })
      ])
    )
  }
}
</script>
